import React from 'react';

import Icon from './Icon';
import { ReactComponent as RectanglesSvg } from './resources/rectangles.svg';
import STYLES from './AllIcons.scss';

const c = className => STYLES[className] || 'UNKNOWN';

const AllIcons = () => {
  return (
    <div className={c('AllIcons')}>
      {Array(24)
        .fill()
        .map((_, index) => (
          <Icon
            key={index.toString()}
            name={`icon_${index.toString()}`}
            contents={RectanglesSvg}
            className={c('AllIcons__icon')}
          />
        ))}
    </div>
  );
};

export default AllIcons;
